/** Situações do GrupoClassificacao */
export interface GrupoClassificacaoSituacao {
    id: number;
    nome: string;
    badge: string;
    canEdit: boolean;
    canDelete: boolean;
}

export const grupoClassificacaoSituacaoAtivo: GrupoClassificacaoSituacao = {
    id: 1,
    nome: 'ATIVO',
    badge: 'badge badge-grupo-classificacao-situacao badge-grupo-classificacao-situacao-ativo',
    canEdit: true,
    canDelete: true
};
export const grupoClassificacaoSituacaoInativo: GrupoClassificacaoSituacao = {
    id: 2,
    nome: 'INATIVO',
    badge: 'badge badge-grupo-classificacao-situacao badge-grupo-classificacao-situacao-inativo',
    canEdit: true,
    canDelete: true
};
export const grupoClassificacaoSituacaoCadastroCliente: GrupoClassificacaoSituacao = {
    id: 3,
    nome: 'CADASTRO DE CLIENTES',
    badge: 'badge badge-grupo-classificacao-situacao badge-grupo-classificacao-situacao-cadastro-cliente',
    canEdit: false,
    canDelete: false
};
export const grupoClassificacaoSituacaoCadastroItem: GrupoClassificacaoSituacao = {
    id: 4,
    nome: 'CADASTRO DE ITENS',
    badge: 'badge badge-grupo-classificacao-situacao badge-grupo-classificacao-situacao-cadastro-item',
    canEdit: false,
    canDelete: false
};

export const grupoClassificacaoSituacoes: GrupoClassificacaoSituacao[] = [
    grupoClassificacaoSituacaoCadastroCliente,
    grupoClassificacaoSituacaoCadastroItem,
    grupoClassificacaoSituacaoAtivo,
    grupoClassificacaoSituacaoInativo
];

/** Verifica se a situação informada é igual a Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === grupoClassificacaoSituacaoAtivo.id;
}

/** Verifica se a situação informada é igual a Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === grupoClassificacaoSituacaoInativo.id;
}

/** Verifica se a situação informada é igual a Cadastro de Clientes */
export function isSituacaoCadastroCliente(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === grupoClassificacaoSituacaoCadastroCliente.id;
}

/** Verifica se a situação informada é igual a Cadastro de Item */
export function isSituacaoCadastroItem(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === grupoClassificacaoSituacaoCadastroItem.id;
}

/** Obtem a situação */
export function getSituacao(situacao: number): GrupoClassificacaoSituacao {
    return grupoClassificacaoSituacoes.find(situacaoFilter => situacaoFilter.id === situacao);
}
